import i18n from "../lang/i18n";

const nameIsLogin = 'is_login';

export default {
    state: {
        isLogin: localStorage.getItem(nameIsLogin) || '',
        lang: localStorage.getItem('lang') || 'ru',
        profile: {
            email: null,
            login: null,
            lang: null,
            timezone: null,
            tag: [],
            is_paid: null,
        },
        profileIsLoaded: false,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        notifications: [],
    },
    mutations: {
        setLogin(state, payload) {
            state.isLogin = payload;
            localStorage.setItem(nameIsLogin, payload)
        },
        setLang(state, payload) {
            state.lang = payload;
            localStorage.setItem('lang', payload)
        },
        setProfile(state, payload) {
            state.profile.email = payload.email;
            state.profile.login = payload.login;
            state.profile.lang = payload.lang;
            state.profile.timezone = payload.timezone;
            state.profile.tag = payload.tag;
            state.profile.is_paid = payload.is_paid;
        },
        setTags(state, payload) {
            state.profile.tag = payload;
        },
        setProfileIsLoaded(state) {
            state.profileIsLoaded = true;
        },
        closeNotification(state, i) {
            state.notifications.splice(i, 1);
        },
        addNotification(state, notification) {

            let getKey = function (notification) {
                return notification.type + '_' + notification.msg;
            }

            let i = state.notifications.map(v => getKey(v)).indexOf(getKey(notification));

            if (i === -1) {
                state.notifications.push(notification);
            }
        }
    },
    getters: {
        isLogin(state) {
            return state.isLogin === 'true';
        },
        lang(state) {
            return state.lang;
        }
    },
    actions: {
        registrationUser(store, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/reg', data, method: 'post', formErrors: formErrors });
        },
        loginUser(store , {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/login', data, method: 'post', formErrors });
        },
        sendConfirmEmail() {
            return this.dispatch('sendRequest', {path: '/user/send-confirm-email', method: 'post'});
        },
        createFollow(store, {data}) {
            return this.dispatch('sendRequest', {path: '/user/follow', data, method: 'post'})
        },
        deleteFollow(store, {id}) {
            return this.dispatch('sendRequest', {path: '/user/follow/'+id, method: 'delete'})
        },
        loadProfile(_, {params}) {
            return this.dispatch('sendRequest', {path: '/user/profile', params});
        },
        loadUserProfile() {
            return this.dispatch('sendRequest', {path: '/user/profile'})
                .then(res => {
                    this.commit('setProfile', res);

                    this.commit('setLang', res.lang);
                    i18n.locale = res.lang;

                    this.commit('setProfileIsLoaded');

                    this.dispatch('loadNotifications');
                });
        },
        changePassword(store, {data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/user/profile/password', method: 'post', data, formErrors});
        },
        createTag(store, {data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/user/profile/tag', method: 'post', data, formErrors});
        },
        updateTag(store, {id, data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/user/profile/tag/'+id, method: 'post', data, formErrors});
        },
        deleteTag(store, {id}) {
            return this.dispatch('sendRequest', {path: '/user/profile/tag/'+id, method: 'delete'});
        },
        updatePersonalInformation(_, {data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/user/profile/personal-information', method: 'post', data, formErrors});
        },
        createPush(store, {data}) {
            return this.dispatch('sendRequest', {path: '/user/push', method: 'post', data});
        },
        loadPush(store, {params}) {
            return this.dispatch('sendRequest', {path: '/user/push/ext-user-id', params});
        },
        logout() {
            return this.dispatch('sendRequest', {path: '/user/logout', method: 'post'});
        },
        loadSessions() {
            return this.dispatch('sendRequest', {path: '/user/session'});
        },
        deleteSession(_, {id}) {
            return this.dispatch('sendRequest', {path: '/user/session/'+id, method: 'delete'});
        },

        loadUserPackages() {
            return this.dispatch('sendRequest', {path: '/user/billing/package'});
        },
        getPaymentLink(_, {data}) {
            return this.dispatch('sendRequest', {path: '/user/billing/order', method: 'post', data});
        },

        loadTelegramSetting() {
            return this.dispatch('sendRequest', {path: '/user/telegram-setting'});
        },
        updateTelegramSetting(_, {data}) {
            return this.dispatch('sendRequest', {path: '/user/telegram-setting', method: 'post', data});
        },

        loadNotifications(store) {
            return this.dispatch('sendRequest', {path: '/user/notification'})
                .then(res => {
                    store.state.notifications = res;
                    return res;
                });
        },
        closeNotification(_, {id}) {
            return this.dispatch('sendRequest', {path: '/user/notification/'+id+'/close', method: 'post'});
        },

        confirmEmail(store, {data}) {
            return this.dispatch('sendRequest', {path: '/confirm-email', data, method: 'post'})
        },
        recoveryPassword(store, {data}) {
            return this.dispatch('sendRequest', {path: '/recovery-pass', data, method: 'post'})
        },
        recoveryPasswordConfirmEmail(store, {data}) {
            return this.dispatch('sendRequest', {path: '/recovery-pass-confirm-email', data, method: 'post'})
        },
    }
}